import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { ErrorInvite } from '@widgets/invite-status/ui/error-invite';
import { SminexEventIcon } from '@shared/assets/icons';
import { palette } from '@shared/tokens/palette.stylex';
import { styles } from '@pages/form-page/styles';

export const FormErrorInvite: FC = () => {
  return (
    <div translate="no" {...stylex.props(styles.containerBlack)}>
      <div {...stylex.props(styles.logoWrapper)}>
        <SminexEventIcon colorPrimary={palette.greyWhite} colorSecondary={palette['bronze-500']} />
      </div>
      <div {...stylex.props(styles.errorInviteContent, styles.errorInviteWrapper)}>
        <ErrorInvite onRetry={() => globalThis.location.reload()} />
      </div>
    </div>
  );
};
